export const appConfig = {
	APIBaseURL: 'https://www.directionsandmaps.app',
	isWebsite: true
};
